import dynamic from "next/dynamic"
import cn from "classnames"
import richText from "utilities/richText"

export default function ImageAndContent({ blok }) {
  const Images =
    blok.images.length < 3
      ? dynamic(() => import("components/SingleImage"))
      : dynamic(() => import("components/ImageCollage"))

  const container = cn("image-content-container flex flex-col gap-4 lg:gap-0 py-12 mx-auto max-w-screen-xl", {
    "lg:flex-row": blok.orientation === "content_first",
    "lg:flex-row-reverse": blok.orientation === "image_first",
  })

  const content = cn(
    "image-content relative z-50 px-6 sm:px-0 basis-1/2 self-center z-10 prose prose-p:py-2",
    {
      "lg:pr-12": blok.orientation === "content_first",
      "lg:pl-12": blok.orientation === "image_first",
    },
    blok.background_color === "white" ||
      blok.background_color === "stone-light" ||
      blok.background_color === "springWood" ||
      blok.background_color === ""
      ? "prose-h2:text-evergreen prose-p:text-charcoal"
      : "prose-h2:text-white prose-p:text-white",
  )

  return (
    <section
      className={cn("sm:px-6", blok.background_color && `bg-${blok.background_color}`)}
      id={blok?.id ? blok?.id : null}
    >
      <div className={container}>
        <div className={content}>{richText(blok.content)}</div>
        <div className="relative z-10 basis-1/2 lg:max-h-[500px] lg:min-h-96">
          <div>
            <Images {...blok} />
          </div>
        </div>
      </div>
    </section>
  )
}
